import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalGenericoModel } from "src/app/shared/models/modal.model";
import { ModalPreguntaListaValorService } from "./modal-pregunta-lista-valor.service";

@Component({
  selector: "app-modal-pregunta-lista-valor",
  templateUrl: "./modal-pregunta-lista-valor.component.html",
  styleUrls: ["./modal-pregunta-lista-valor.component.scss"],
})
export class ModalPreguntaListaValorComponent implements OnInit {
  @Input()
  modalGenerico: ModalGenericoModel;
  formFormulaPregunta: FormGroup;
  infoPregunta: any;
  isAditional: any;
  pregunta_id: number;

  origenesValorLista: Array<any> = [];
  preguntaOrigenLista: Array<any> = [];
  opcionesLista: Array<any> = [];

  hasKey: boolean = true;
  hasDepVal: boolean = false;
  isEditing: boolean = false;

  data: any;

  constructor(
    private activeModal: NgbActiveModal,
    private modalPreguntaEncuestaService: ModalPreguntaListaValorService,
    public formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.pregunta_id = this.isAditional ?
      this.infoPregunta.pregunta_adicional_encuesta_id :
      this.infoPregunta.pregunta_encuesta_id;

    this.modalGenerico = {
      titulo: "",
    };
    this.createForm();
    if (this.data) {
      this.isEditing = true;

      if (this.isAditional) {

        if (this.data.pregunta_adicional_encuesta_id_dependencia < 1) this.hasKey = false;
        else this.hasDepVal = true;
      } else {

        if (this.data.pregunta_encuesta_id_dependencia < 1) this.hasKey = false;
        else this.hasDepVal = true;
      }
    } else this.hasKey = false;
  }

  cambiarOrigen(value: any) {
    const origenes_lista_valor_id = this.formFormulaPregunta.value.origenes_lista_valor_id;
    if (!isNaN(origenes_lista_valor_id)) {
      const valor = this.origenesValorLista.reduce((acc, el) => {
        if (origenes_lista_valor_id === el.origenes_lista_valor_id)
          return el.llave.trim().length > 0 ? true : false;
        else return acc;
      }, false);

      if (this.isAditional) this.formFormulaPregunta.value.pregunta_adicional_encuesta_id_dependencia = null;
      else this.formFormulaPregunta.value.pregunta_encuesta_id_dependencia = null;

      this.hasKey = valor;
    } else this.hasKey = false;
  }

  cambiarDependencia(value: any) {
    if (value !== null) this.hasDepVal = true;
    else this.hasDepVal = false;
  }

  createForm() {
    if (this.isAditional) {
      this.formFormulaPregunta = this.formBuilder.group({
        pregunta_adicional_encuesta_id: [this.infoPregunta.pregunta_adicional_encuesta_id, Validators.required],
        origenes_lista_valor_id: [this.data?.origenes_lista_valor_id ?? null, Validators.required],
        pregunta_adicional_encuesta_id_dependencia: [(this.data?.pregunta_adicional_encuesta_id_dependencia > 0 ?
          this.data?.pregunta_adicional_encuesta_id_dependencia : null) ?? null, Validators.required],
      });
    } else {
      this.formFormulaPregunta = this.formBuilder.group({
        pregunta_encuesta_id: [this.infoPregunta.pregunta_encuesta_id, Validators.required],
        origenes_lista_valor_id: [this.data?.origenes_lista_valor_id ?? null, Validators.required],
        pregunta_encuesta_id_dependencia: [(this.data?.pregunta_encuesta_id_dependencia > 0 ?
          this.data?.pregunta_encuesta_id_dependencia : null) ?? null, Validators.required],
      });
    }
  }

  dismiss(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }

  close(): void {
    if (this.activeModal) {
      this.activeModal.close({ form: this.formFormulaPregunta.value, isEditing: this.isEditing });
    }
  }
}
